import type { Attachment } from '../files.types';
import { FileRow } from './FileRow';

interface FilesListProps {
  attachments: Attachment[];
  deletingId: string | null;
  onDelete: (id: string) => void;
}

/** Dumb: the attachment list. */
export function FilesList({ attachments, deletingId, onDelete }: FilesListProps): JSX.Element {
  return (
    <ul className="divide-y divide-gray-100 dark:divide-gray-700">
      {attachments.map((att) => (
        <FileRow
          key={att.id}
          attachment={att}
          isDeleting={deletingId === att.id}
          onDelete={onDelete}
        />
      ))}
    </ul>
  );
}
